/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIUserAutocompleteSuggestion } from './APIUserAutocompleteSuggestion';
import {
    APIUserAutocompleteSuggestionFromJSON,
    APIUserAutocompleteSuggestionFromJSONTyped,
    APIUserAutocompleteSuggestionToJSON,
} from './APIUserAutocompleteSuggestion';

/**
 * 
 * @export
 * @interface APIUserAutocompleteResponse
 */
export interface APIUserAutocompleteResponse {
    /**
     * 
     * @type {Array<APIUserAutocompleteSuggestion>}
     * @memberof APIUserAutocompleteResponse
     */
    suggestions: Array<APIUserAutocompleteSuggestion>;
    /**
     * 
     * @type {number}
     * @memberof APIUserAutocompleteResponse
     */
    total: number;
}

/**
 * Check if a given object implements the APIUserAutocompleteResponse interface.
 */
export function instanceOfAPIUserAutocompleteResponse(value: object): value is APIUserAutocompleteResponse {
    if (!('suggestions' in value) || value['suggestions'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function APIUserAutocompleteResponseFromJSON(json: any): APIUserAutocompleteResponse {
    return APIUserAutocompleteResponseFromJSONTyped(json, false);
}

export function APIUserAutocompleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIUserAutocompleteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestions': ((json['suggestions'] as Array<any>).map(APIUserAutocompleteSuggestionFromJSON)),
        'total': json['total'],
    };
}

export function APIUserAutocompleteResponseToJSON(value?: APIUserAutocompleteResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'suggestions': ((value['suggestions'] as Array<any>).map(APIUserAutocompleteSuggestionToJSON)),
        'total': value['total'],
    };
}

